import {
  Box,
} from '@mui/material';
import Places from '../Places/Places';
import ImageCarousel from '../../Components/ ImageCarousel';
import LocationComponent from '../../Components/Map/LocationComponent';
import { RootState } from '../../store/rootReducers';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '../../Utils/request';
import DashboardPlaceScreen from './DashboardPlaceScreen';
import { setDashboard } from '../../store/slices/DashboardSlice';
import DashboardTripScreen from './DashboardTripScreen';
import DashboardTopBar from './DashboardTopBar';
import UserSearchFab from '../../Components/Fab/UserSearchFab';


const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const banners = useSelector((state: RootState) => state.dashboard.introSliders);
  const location = useSelector((state: RootState) => state.location.location);

  useEffect(() => {
    if (Notification.permission !== 'granted' && !(window as any).__notificationMsgShown) {
      (window as any).__notificationMsgShown = true;
      window.dispatchEvent(
        new CustomEvent('app-toast', {
          detail: {
            message: 'Enable notifications from browser settings to never miss updates',
            type: 'warning',
            onClick: async () => {
              const result = await Notification.requestPermission();
              if (result === 'granted') {
                window.dispatchEvent(
                  new CustomEvent('app-toast', {
                    detail: { message: 'Notifications enabled!', type: 'success' },
                  }),
                );
              } else {
                window.open('https://support.google.com/chrome/answer/3220216', '_blank');
              }
            },
          },
        }),
      );
    }
    const fetchLanding = async () => {
      let endpoint = '/landing';
      
      // Add location parameters if available
      if (location?.lat && location?.lng) {
        const queryParams = new URLSearchParams({
          latitude: location.lat.toString(),
          longitude: location.lng.toString(),
        });
        endpoint = `${endpoint}?${queryParams.toString()}`;
      }
      
      const res = await request(endpoint, {
        method: 'GET',
      }) as any;
      console.log("landing",res.data);
      dispatch(setDashboard({
        banners: res.data.banners,
        introSliders: res.data.introSliders,
        categories: res.data.postCategories,
        newPlaces: res.data.newPlaces,
        curatedPlaces: res.data.curatedPlaces,
        tripsItinerary: res.data.tripsItinerary,
      }));
    }
    fetchLanding();
  }, [location]);

  // Check intro slider condition and navigate if needed
  useEffect(() => {
    const hasSeenIntro = localStorage.getItem('hasSeenIntroSlider');
    if (!hasSeenIntro && banners && banners.length > 0) {
      navigate('/intro');
    }
  }, [banners, navigate]);

  return (
    <>
      <DashboardTopBar />
          <ImageCarousel/>
      <Box p={2} sx={{ mb:6 }}>
          <DashboardPlaceScreen title="Nearby places" />
          <DashboardTripScreen  />
          <DashboardPlaceScreen title="Newly added places" noCategories />
        {/* <Places/> */}
      </Box>
      <LocationComponent/>
      <UserSearchFab />
    </>
  );
};

export default Dashboard;
